<template>
	<app-page>
		<app-heading title="Manual Tests" />
		<app-row>
			<app-cell cols="12" md="4">
				<app-section>
					<h2>Jobs</h2>
					<app-row class="mt-4">
						<app-cell align-self="center">Job progression</app-cell>
						<app-cell class="text-right">
							<app-button
								color="secondary"
								outlined
								small
								@click="triggerEvent('test.job.progress', 'jobs-working')"
							>Test</app-button>
						</app-cell>
					</app-row>
					<app-row>
						<app-cell align-self="center">Job chaining</app-cell>
						<app-cell class="text-right">
							<app-button
								color="secondary"
								outlined
								small
								@click="triggerEvent('test.job.chain', 'jobs-working')"
							>Test</app-button>
						</app-cell>
					</app-row>
					<app-row>
						<app-cell align-self="center">Job failure</app-cell>
						<app-cell class="text-right">
							<app-button
								color="secondary"
								outlined
								small
								@click="triggerEvent('test.job.fail', 'jobs')"
							>Test</app-button>
						</app-cell>
					</app-row>
				</app-section>
			</app-cell>
			<app-cell cols="12" md="4">
				<app-section>
					<h2>Events</h2>
					<app-row class="mt-4">
						<app-cell align-self="center">Event delay</app-cell>
						<app-cell class="text-right">
							<app-button
								color="secondary"
								small
								outlined
								@click="triggerEvent('test.delay', 'events-scheduled', 5)"
							>Test</app-button>
						</app-cell>
					</app-row>
					<app-row>
						<app-cell align-self="center">Event failure</app-cell>
						<app-cell class="text-right">
							<app-button
								color="secondary"
								small
								outlined
								@click="triggerEvent('test.fail', 'events')"
							>Test</app-button>
						</app-cell>
					</app-row>
				</app-section>
			</app-cell>
			<app-cell cols="12" md="4">
				<app-section>
					<h2>Issues</h2>
					<app-row class="mt-4">
						<app-cell align-self="center">New issue</app-cell>
						<app-cell class="text-right">
							<app-button-confirm
								color="secondary"
								small
								outlined
								label-confirm="Test"
								custom
								@click="testIssue"
								@close="issue.type = null"
							>
								<template v-slot:body>
									<app-dialog-body>
										<div>Test issue</div>
										<input-select
											v-model="issue.type"
											label="Issue type"
											:items="issueTypes"
										/>
									</app-dialog-body>
								</template>
								Test
							</app-button-confirm>
						</app-cell>
					</app-row>
				</app-section>
			</app-cell>
			<app-cell cols="12" md="4">
				<app-section>
					<h2>Emails</h2>
					<app-row class="mt-4">
						<app-cell align-self="center">Send Test</app-cell>
						<app-cell class="text-right">
							<app-button
								color="secondary"
								small
								outlined
								@click="testEmail"
							>
								Test
							</app-button>
						</app-cell>
					</app-row>
				</app-section>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			issue: {
				type: null,
			},
			issueTypes: [{
				text: 'Error',
				value: 'error',
			}, {
				text: 'Warning',
				value: 'warning',
			}, {
				text: 'Deprecated',
				value: 'deprec',
			}],
		}
	},
	methods: {
		async triggerEvent(name, redirect, delay = 0) {
			this.$store.dispatch('app/startLoading')

			try {
				await this.$ravello.request()
					.to('system')
					.to('events')
					.to('trigger')
					.create({
						event: name,
						...(delay ? { delay } : {}),
					})
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')

			this.$router.push({ name: redirect })
		},

		async testIssue() {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.to('system')
					.to('issues')
					.to('test')
					.create({
						...(this.issue.type ? { type: this.issue.type } : {}),
					})
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
			this.$router.push({ name: 'system-issues' })
		},

		async testEmail() {
			this.$store.dispatch('app/startLoading')
			try {
				await this.$ravello.request()
					.to('system')
					.to('email')
					.to('test')
					.create()

				this.$notifications.pushAlert('success', 'Check your emails')
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
			this.$store.dispatch('app/stopLoading')
		},
	},
}
</script>
